import { motion } from "framer-motion";

export default function Salesforce() {
  return (
    <div className="section">

      {/* HERO */}
      <div className="container" style={{ textAlign: "center" }}>
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          className="section-title"
        >
          Enterprise Salesforce Implementation & Development
        </motion.h1>

        <p style={{ maxWidth: "850px", margin: "20px auto" }}>
          From Salesforce admin setup to advanced Apex development and integrations,
          we build scalable, secure, and fully automated CRM systems tailored to your business.
        </p>

 
      </div>

      {/* TRUST */}
      <div className="container" style={{ textAlign: "center", marginTop: "60px" }}>
        <div className="process">
          <div>PD2 Certified Developer</div>
          <div>6+ Salesforce Certifications</div>
          <div>End-to-End Implementation</div>
          <div>Enterprise-Ready Systems</div>
        </div>
      </div>

      {/* ADMIN */}
      <div className="container" style={{ marginTop: "100px" }}>
        <h2 className="section-title">Salesforce Admin & Configuration</h2>

        <div className="services">
          <div className="service-card">
            <h3>Data Model Design</h3>
            <p>Custom objects, relationships, and scalable data architecture.</p>
          </div>

          <div className="service-card">
            <h3>Users & Permissions</h3>
            <p>Profiles, roles, permission sets, and secure access control.</p>
          </div>

          <div className="service-card">
            <h3>Page Layouts & UI</h3>
            <p>Lightning pages, dynamic forms, and optimized user experience.</p>
          </div>

          <div className="service-card">
            <h3>Validation & Data Quality</h3>
            <p>Validation rules and data integrity enforcement.</p>
          </div>
        </div>
      </div>

      {/* AUTOMATION */}
      <div className="container" style={{ marginTop: "100px" }}>
        <h2 className="section-title">Automation & Business Logic</h2>

        <div className="services">
          <div className="service-card">
            <h3>Flows & Process Automation</h3>
            <p>Advanced flows for lead routing, approvals, and automation.</p>
          </div>

          <div className="service-card">
            <h3>Approval Processes</h3>
            <p>Multi-level approval workflows for enterprise operations.</p>
          </div>

          <div className="service-card">
            <h3>Email & Notifications</h3>
            <p>Automated alerts, triggers, and communication systems.</p>
          </div>

          <div className="service-card">
            <h3>Business Process Optimization</h3>
            <p>Eliminate manual work with fully automated systems.</p>
          </div>
        </div>
      </div>

      {/* DEVELOPMENT */}
      <div className="container" style={{ marginTop: "100px" }}>
        <h2 className="section-title">Custom Development</h2>

        <div className="services">
          <div className="service-card">
            <h3>Apex Classes & Triggers</h3>
            <p>Custom backend logic for complex workflows and automation.</p>
          </div>

          <div className="service-card">
            <h3>Lightning Web Components (LWC)</h3>
            <p>Modern, fast, and scalable UI components.</p>
          </div>

          <div className="service-card">
            <h3>Aura Components</h3>
            <p>Enhancement and maintenance of legacy systems.</p>
          </div>

          <div className="service-card">
            <h3>Custom APIs</h3>
            <p>REST & SOAP APIs for seamless integrations.</p>
          </div>
        </div>
      </div>

      {/* INTEGRATIONS */}
      <div className="container" style={{ marginTop: "100px" }}>
        <h2 className="section-title">Integrations & Architecture</h2>

        <div className="services">
          <div className="service-card">
            <h3>Third-Party Integrations</h3>
            <p>Payment gateways, ERPs, marketing tools, and external apps.</p>
          </div>

          <div className="service-card">
            <h3>Data Migration</h3>
            <p>Secure migration from legacy systems into Salesforce.</p>
          </div>

          <div className="service-card">
            <h3>API Integrations</h3>
            <p>Real-time sync between Salesforce and external systems.</p>
          </div>

          <div className="service-card">
            <h3>System Architecture</h3>
            <p>Scalable CRM systems designed for long-term growth.</p>
          </div>
        </div>
      </div>

      {/* DEVOPS */}
      <div className="container" style={{ marginTop: "100px" }}>
        <h2 className="section-title">DevOps & Deployment</h2>

        <div className="services">
          <div className="service-card">
            <h3>CI/CD Pipelines</h3>
            <p>Automated deployments using modern DevOps tools.</p>
          </div>

          <div className="service-card">
            <h3>Version Control</h3>
            <p>Git-based workflows for safe and scalable development.</p>
          </div>

          <div className="service-card">
            <h3>Sandbox Strategy</h3>
            <p>Dev, QA, and staging environments for safe releases.</p>
          </div>

          <div className="service-card">
            <h3>SFDX Setup</h3>
            <p>Modern Salesforce DX development environment.</p>
          </div>
        </div>
      </div>

      {/* DATA */}
      <div className="container" style={{ marginTop: "100px" }}>
        <h2 className="section-title">Data & Reporting</h2>

        <div className="services">
          <div className="service-card">
            <h3>Reports & Dashboards</h3>
            <p>Real-time analytics and business insights.</p>
          </div>

          <div className="service-card">
            <h3>Sales Forecasting</h3>
            <p>Accurate revenue predictions and pipeline tracking.</p>
          </div>

          <div className="service-card">
            <h3>Data Modeling</h3>
            <p>Optimized data structures for performance and scalability.</p>
          </div>

          <div className="service-card">
            <h3>Data Cleanup</h3>
            <p>Remove duplicates and maintain clean CRM data.</p>
          </div>
        </div>
      </div>

      {/* SECURITY */}
      <div className="container" style={{ marginTop: "100px" }}>
        <h2 className="section-title">Security & Compliance</h2>

        <div className="services">
          <div className="service-card">
            <h3>Access Control</h3>
            <p>Roles, profiles, and permission sets.</p>
          </div>

          <div className="service-card">
            <h3>Field-Level Security</h3>
            <p>Granular control over sensitive data.</p>
          </div>

          <div className="service-card">
            <h3>Sharing Rules</h3>
            <p>Secure data visibility across teams.</p>
          </div>

          <div className="service-card">
            <h3>Compliance Ready</h3>
            <p>Enterprise-grade data protection standards.</p>
          </div>
        </div>
      </div>

      {/* INDUSTRIES */}
      <div className="container" style={{ marginTop: "100px", textAlign: "center" }}>
        <h2 className="section-title">Industries We Serve</h2>

        <div className="tech-stack">
          <div className="tech">Ecommerce</div>
          <div className="tech">SaaS</div>
          <div className="tech">Real Estate</div>
          <div className="tech">Healthcare</div>
          <div className="tech">Agencies</div>
        </div>
      </div>

      {/* PROCESS */}
      <div className="container" style={{ marginTop: "100px" }}>
        <h2 className="section-title">Our Process</h2>

        <div className="process">
          <div>1. Requirement Analysis</div>
          <div>2. System Design</div>
          <div>3. Development</div>
          <div>4. Testing & Deployment</div>
          <div>5. Training & Support</div>
        </div>
      </div>

      {/* DELIVERABLES */}
      <div className="container" style={{ marginTop: "100px", textAlign: "center" }}>
        <h2 className="section-title">What You Get</h2>

        <div className="process">
          <div>✔ Fully Configured CRM</div>
          <div>✔ Automated Workflows</div>
          <div>✔ Custom Development</div>
          <div>✔ Integrations</div>
          <div>✔ Documentation & Training</div>
        </div>
      </div>

      {/* CTA */}
      <div className="container" style={{ textAlign: "center", marginTop: "100px" }}>
        <h2>Build Your Salesforce System the Right Way</h2>
        <p>
          From admin setup to enterprise development — we handle everything end-to-end.
        </p>

        <a href="/contact" className="btn-primary">
          Start Your Project
        </a>
      </div>

    </div>
  );
}